import { render, staticRenderFns } from "./prescriptionDesc.vue?vue&type=template&id=1a728942&scoped=true"
import script from "./prescriptionDesc.vue?vue&type=script&lang=js"
export * from "./prescriptionDesc.vue?vue&type=script&lang=js"
import style0 from "./prescriptionDesc.vue?vue&type=style&index=0&id=1a728942&prod&lang=scss"
import style1 from "./prescriptionDesc.vue?vue&type=style&index=1&id=1a728942&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a728942",
  null
  
)

export default component.exports